import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import type { NormalizedDMsAndLBs } from './types';
import { processDMConnectionData } from './utils/processDMConnectionData';
import { processLBConnectionData } from './utils/processLBConnectionData';

type Result = ModelHookResult<{
	dmsAndLBs: NormalizedDMsAndLBs;
	displayViewAllButton: boolean;
	totalDmCount: number;
}>;

export function useLegislativeBodiesContainer(): Result {
	const {
		data: {
			petition: { dmsWithLegislativeBodiesConnection, primaryDecisionMakerConnection, dmResponsesConnection },
			featureConfigs: { dmWithLegislativeBodiesConnectionEnabled },
		},
	} = usePetitionDetailsPageData();

	const { displayViewAllButton, dmsAndLBs, totalDmCount } = dmWithLegislativeBodiesConnectionEnabled
		? processLBConnectionData(dmsWithLegislativeBodiesConnection)
		: processDMConnectionData(primaryDecisionMakerConnection, dmResponsesConnection.nodes);

	return { data: { displayViewAllButton, dmsAndLBs, totalDmCount } };
}
